import React from 'react';
import './LugaresHistoricos.css';

import ErmitaEstrellaImg   from '../../Images/ErmitaEstrella.png';
import ErmitaSoledadImg    from '../../Images/ErmitaSoledad.jpg';
import IglesiaPrincipalImg from '../../Images/IglesiaPrincipal.jpg';
import CanoViejoImg        from '../../Images/CanoViejo.jpg';
import PozoDulceImg        from '../../Images/PozoDulce.jpg';
import AyuntamientoImg     from '../../Images/Ayuntamiento.jpg';

const LugaresHistoricos = () => (
  <div className="lugares-historicos-container">
    <h1>Lugares Históricos de Escalonilla</h1>
    <p className="intro-text">
      En Escalonilla la historia se palpa a cada paso: retablos barrocos, ermitas populares,
      fuentes centenarias o el propio Ayuntamiento decimonónico conforman un patrimonio
      del que los escalonilleros nos sentimos orgullosos.
    </p>

    {/* 1 ▸ IGLESIA PARROQUIAL */}
    <div className="historico-section">
      <h2>Iglesia Parroquial de <em>Santa María Magdalena</em></h2>
      <div className="historicos-content">
        <div className="historicos-text">
          <p>
            Primer templo (s. XVI) arruinado al desplomarse la bóveda el <b>24-VI-1577</b>
            –murieron trece vecinos durante la novena de San Juan–. El Concejo solicitó
            maestros del cabildo toledano; en <b>Navidad de 1583</b> ya se celebraba misa en
            la nave reconstruida, de <u>cruz latina</u> y tres tramos cubiertos por artesón
            mudéjar reutilizado del edificio anterior.
          </p>
          <p>
            El magnífico <b>retablo mayor</b> (9,10 × 7,60 m) fue ensamblado en <b>1712-14</b> por
            <i>Andrés de Huerta</i>. Su financiación es curiosísima: el Concejo cedió cada año
            <em>diez fanegas de tierra «a peujar»</em>; el trigo cosechado (318 fanegas)
            se vendió en 1707 y 1709, aunque el primer mayordomo &mdash;Diego López
            Ayllón&mdash; fue multado por revenderlo sin licencia (14 394 rs). En la
            calle central observamos el lienzo barroco <b><i>Tránsito de Santa María
            Magdalena a los Cielos</i></b>, copia madrileña de finales del XVII.
          </p>
          <p>
            Otras piezas singulares:
            <br />• <b>Órgano (1742)</b>, caja de tres castillos atribuidos a Diego de
            Céspedes.<br />
            • <b>Imagen titular</b> (madera policromada, Juan Pascual de Mena, ca. 1760),
            elegante túnica de palma entrelazada.<br />
            • Pila bautismal gótica (granito, s. XV) proveniente del despoblado de
            Casas Albas.
          </p>
          <p>
            Entre <b>2002-2004</b> se restauró todo el retablo gracias a un
            <em>crowdfunding</em> vecinal: emigrantes enviaron donativos desde
            Cataluña, País Vasco, Francia o Argentina; «una lección para la Historia»
            tituló la revista local.
          </p>
        </div>
        <div className="historicos-image">
          <img src={IglesiaPrincipalImg} alt="Iglesia Santa María Magdalena" />
        </div>
      </div>
    </div>

    {/* 2 ▸ CASAS CONSISTORIALES */}
    <div className="historico-section">
      <h2>Casas Consistoriales (Ayuntamiento)</h2>
      <div className="historicos-content">
        <div className="historicos-text">
          <p>
            El primitivo ayuntamiento de tapial y pórtico de madera fue declarado
            «indecoroso e inseguro» en 1878. Se acordó derribarlo y alzar uno nuevo
            con reloj de torre para sustituir al mecanismo de la parroquia.
          </p>
          <p>
            • Proyecto: <b>Santiago Martín y Ruiz</b>, arquitecto provincial
            (<i>9-VIII-1879</i>, 19 522 ptas).<br />
            • Tres subastas: la primera quedó desierta; la segunda la ganó el
            farmacéutico Manuel A. Alía pero renunció; la definitiva (<i>1-IV-1880</i>)
            recayó en <b>Basilio Fernández Escamilla</b> (17 200 ptas).<br />
            • Para costearlo se arrendó durante seis años el <i>prado comunal del
            Chapatal</i> (30 ha) y se vendió la vieja balanza del peso público.
          </p>
          <p>
            El edificio combina ladrillo prensado y sillería de granito; luce balconada
            corrida, escudo isabelino y la leyenda <b>«Casas Consistoriales»</b> grabada
            donde originalmente rezaba «Plaza de la Constitución». El reloj Girves
            (1881) sigue dando las horas… siempre que el viento no frene el
            péndulo.
          </p>
        </div>
        <div className="historicos-image">
          <img src={AyuntamientoImg} alt="Ayuntamiento de Escalonilla" />
        </div>
      </div>
    </div>

    {/* 3 ▸ ERMITA VIRGEN DE LA ESTRELLA */}
    <div className="historico-section">
      <h2>Ermita de la Virgen de la Estrella</h2>
      <div className="historicos-content">
        <div className="historicos-text">
          <p>
            Humilladero ya citado en <b>1678</b> a la salida norte de la villa, junto a la
            Cañada Real Segoviana. Allí los ganaderos post-mediaban «para que los
            cielos sean propicios». Las visitas de 1704 y 1720 describen altar de
            yeso, cruz de madera y campanilla.
          </p>
          <p>
            A finales del XIX una severa epidemia de carbunco motivó novenarios
            bajo la advocación de «Nuestra Señora Estrella, luz contra la peste». El
            crucero pétreo de 1889 aún se conserva. Tras décadas de abandono, la
            estructura colapsó en 1955; la cofradía guardó la imagen en domicilios
            particulares.
          </p>
          <p>
            <b>Rehabilitación 1992-94:</b> la Escuela-Taller numeró ladrillos originales y
            repuso fábrica con cal aérea; la firma local <i>Garlopilo</i> donó más de 6 000 u.
            de teja curva. Se añadió espadaña sencilla, pavimento de canto rodado
            y poyo corrido para los romeros.
          </p>
          <p>
            La <u>romería</u> (primer domingo de mayo) reúne carros engalanados con
            esparto, grupo de folclore local y «puja del ramo»; el alcalde entrega la
            <em>medalla de mayordomo</em> al licitador que más altas Varas de
            horquilla subaste.
          </p>
        </div>
        <div className="historicos-image">
          <img src={ErmitaEstrellaImg} alt="Ermita de la Virgen de la Estrella" />
        </div>
      </div>
    </div>

    {/* 4 ▸ ERMITA DE LA SOLEDAD */}
    <div className="historico-section">
      <h2>Ermita de Nuestra Señora de la Soledad</h2>
      <div className="historicos-content">
        <div className="historicos-text">
          <p>
            Antigua ermita de <b>San Sebastián</b>. En 1765 la joven Cesárea López
            Nombela (17 años) lega todos sus bienes &mdash;33 717 rs.&mdash; «para que se
            concluya su hermita». Con ese capital se construye la fábrica actual
            (1770): nave única, bóvedas de arista, cornisa de yeserías barrocas y
            espadaña de ladrillo.
          </p>
          <p>
            <u>Acto inaugural 6-X-1770:</u> presidido por el canónigo escalonillero
            D. Diego Moreno Ortiz; participaron cinco hermandades, se quemaron
            600 rs. de pólvora y tocaron los <i>chirimeros de Carmena</i>. En los altares
            laterales se situaron San Francisco Xavier y el antiguo San Sebastián.
          </p>
          <p>
            Costes documentados: 17 075 rs. en piedra, ladrillo y madera;
            campana de 42 kg fundida por Hilario Villatoro; empedrado original de
            canto rodado todavía visible tras la restauración de 1999.
          </p>
          <p>
            La imagen barroca fue destruida en 1936; la talla actual (Olot, 1940)
            preside el Viernes Santo y la misa de difuntos del 1-XI. Su patio alberga
            ciprés centenario y antiguos «postes de luminaria» de los serenos.
          </p>
        </div>
        <div className="historicos-image">
          <img src={ErmitaSoledadImg} alt="Ermita de la Soledad" />
        </div>
      </div>
    </div>

<div className="historico-section">
  <h2>El Caño Viejo </h2>
  <div className="historicos-content">
    <div className="historicos-text">
      <p>
        Fuente pública y pilón rectangular levantado junto a la actual 
        <b> Plaza de la Fuente</b>.  En <b>1817</b> se encontraba arruinado: «no
        almacena ni una gota de agua».  El Concejo contrata al maestro
        portugués <i>José Ruiz Cabanas</i> por 5 000 reales para demolerlo y
        rehacerlo «con mezcla de cal, aceite, claras de huevo y pelo de cabra».
        Una segunda intervención (1819) documenta empedrado perimetral y
        solado interior de sillares.
      </p>
      <p>
        El pilón mide 14 m de largo y 1,8 m de profundidad; abasteció al
        ganado trashumante que descendía por la Cañada Real Segoviana y a los
        vecinos hasta 1978 (entrada del agua corriente).  
        Restaurado en <b>1996</b> por la Escuela-Taller: se repuso la sillería
        perdida, se estucó con mortero de cal y se añadió barandilla de forja
        para su protección.  Hoy es <u>símbolo sentimental</u> del patrimonio
        escalonillero: «<i>Caño Viejo, nunca dejes de correr…</i>».
      </p>
    </div>
    <div className="historicos-image">
      <img src={CanoViejoImg} alt="Fuente del Caño Viejo" />
    </div>
  </div>
</div>

  </div>
);

export default LugaresHistoricos;
